package com.islamicmedia.shared.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class DisambiguationItem(
    val title: String,
    val year: String? = null,
    val info: String? = null,
    val mediaType: String? = null,
    /** Book author (e.g. "J.K. Rowling"). Only populated for mediaType "book". */
    val author: String? = null,
    /** Pre-resolved cover (currently only ISBN-scanned books) so the UI can show
     *  art immediately, before the server resolves/streams its own coverUrl. */
    val coverUrl: String? = null
)
